import Row from '@sdk/components/ui/spacing/Row';

import { PricingSummaryText } from '@web/account/billing/CurrentBillingPricing/currentBillingPricing.styles';

type Props = {
  value: number | string;
  label: string;
  semiBold?: boolean;
};

export const PricingSummaryRow = ({ value, label, semiBold }: Props) => (
  <Row alignItems="center">
    <PricingSummaryText semiBold={semiBold}>{label}</PricingSummaryText>
    <Row mLeft={'auto'}>
      <PricingSummaryText semiBold={semiBold}>{value}</PricingSummaryText>
    </Row>
  </Row>
);
